import React, { useState, useEffect, useId } from "react";
import { Form, Button, Alert } from "antd";
import dot from 'dot-object';
import i18next from "i18next"

import { renderNestedInputs } from "./RenderForm";
import {
  getFormItem,
  getFormTitles,
  getInputLabel,
  layoutTypes,
  showHideInput
} from "./helper";
import CustomWrapper from "../ViewCADD/components/customWrapper";
import { useTranslation } from "react-i18next";
import { propHasValue } from "../../components/DynamicFormNew/helper";
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import dayjs from "dayjs";
import TypesOfRisksCovered from "../ViewCADD/components/warningComponents/typesOfRisksCovered";
import AdditionalCRAFTRequirements from "../ViewCADD/components/warningComponents/additionalCRAFTRequirements";

const NestedInput = ({
  options,
  k,
  setValues,
  values,
  excludedKeys,
  i,
  formTitles,
  getData,
  MainForm,
  plainForms,
  setAddress,
  currentField,
  setCurrentField,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  return renderNestedInputs(
    options,
    k,
    setValues,
    values,
    excludedKeys,
    i,
    formTitles,
    getData,
    MainForm,
    plainForms,
    setAddress,
    currentField,
    setCurrentField,
    isModalVisible,
    setIsModalVisible,
  );
};

export const EditForm = ({
  onValuesChange = () => { },
  form,
  data,
  allData = {},
  excludedKeys = [],
  disabledInputs = [],
  checkDuplicates = true,
  plainForms = {},
  hasSections = false,
  linkingForms = {},
  onSubmit = () => { },
  onCancel = () => { },
  isModal = false,
  breadcrumb = null,
  MainForm,
  layout = layoutTypes.DEFAULT,
  setLoading = () => { },
}) => {
  const formData = JSON.parse(JSON.stringify(data || {}))
  const allFormData = JSON.parse(JSON.stringify(allData || {}))
  const [values, setValues] = useState(formData || {});
  const allValues = allFormData || {};
  const [addressData, setAddress] = useState({});
  const uuid = useId();
  const { t } = useTranslation();
  // const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentField, setCurrentField] = useState(null);
  const { id, options = {}, introText, formTitles, formClass = '' } = form || {};
  excludedKeys.push('icon', 'label', 'description', 'showFormIf', 'sectionLabel', 'formDescription', 'introText', 'formClass', 'alertConf', 'formTitles', 'position', 'id');

  const getData = (name, input, value, commentValue, path, disabledPath) => {
    const props = {
      placeholder: input.placeholder ? input.placeholder : getInputLabel(input, values, true),
      valueplaceholder: input.valueLabel || null,
      disabled: input.disabled || false,
      accept: input.accept || undefined,
    }

    if (disabledInputs.includes(disabledPath)) {
      props.disabled = true;
    }

    if (input.inputType === 'total100' && !value) {
      value = [{
        type: null,
        value: null
      }];
    } else if (['date', 'year'].includes(input.inputType)) {
      value = value ? dayjs(value) : undefined;
    } else if (input.inputType === 'switch' && !input.optionGroup) {
      if (!propHasValue(value)) {
        value = value || false;
        if (typeof path === 'string') {
          dot.str(path, value, values);
        }
      }
    } else if (input.inputType === 'upload' || input.inputType === 'imageUpload') {
      const fileList = (
        Array.isArray(value) ? value :
          (
            value &&
              typeof value === 'object' &&
              value.fileList &&
              Array.isArray(value.fileList) ?
              value.fileList.map(f => f.response ? f.response : f).filter(f => f) : []
          )
      ) || [];
      if (!Array.isArray(value) && value &&
        typeof value === 'object' &&
        value.fileList &&
        Array.isArray(value.fileList)) {
        if (typeof path === 'string') {
          dot.set(path, fileList, values);
        }
      }
      value = fileList;
    }

    if (input.inputType === 'modal') {
      props.linkingform = {};
      props.datalink = input.dataLink;
      if (linkingForms[name]) {
        props.linkingform = linkingForms[name];
      }
    }

    const config = {
      name,
      call: input.call,
      automaticallyLink: input.automaticallyLink,
      props,
      formsValue: values,
      allFormsValue: allFormData,
      onNewSetValue: input.onNewSetValue,
      multiple: input.multiple,
      updateOptions: input.updateOptions || false,
      options: input.options,
      optionGroup: input.optionGroup,
      optionsFilter: input.optionsFilter,
      filterCond: input.filterCond,
      disableOtherFields: input.disableOtherFields,
      updateOtherFields: input.updateOtherFields,
      repeatLabel: input.repeatLabel,
      unique: checkDuplicates ? input.unique : undefined,
      modalTitle: input.modalTitle,
      buttonText: input.buttonText,
      restricted: input.restricted || false,
      totalMax: input.totalMax,
      country: input.country || undefined,
      address: input.address || undefined,
      addressData,
      value,
      allowDupplicates: input.allowDupplicates,
      commentValue,
      commentHint: input.commentHint ? input.commentHint : i18next.t('Please specify'),
      rules: (input.rules || []).map(r => {
        if (r.message && r.message.indexOf('errors::') >= 0) {
          r.message = i18next.t(r.message);
        }
        return r;
      }),
      template: input.template,
    };

    if (input.inputType === 'switch' && input.autocomplete) {
      Object.assign(config, { autocomplete: input.autocomplete });
    }

    if (input.inputType === 'switch') {
      if (input.replace) {
        Object.assign(config, { replace: input.replace });
      }
      if (input.unique) {
        Object.assign(config, { unique: input.unique });
      }
    }

    if (input.inputType === 'linkingModal') {
      Object.assign(config, {
        content: input.inputs
      });
    }

    if (input.inputType === 'group') {
      Object.assign(config, {
        groupInputs: Object.keys(input.groupInputs).map(key => {
          const isRep = path.split('.')[0].match(/\[/);
          const newPath = path.split('.').length === 1
            ? key
            : (isRep && isRep.length ? path.split('.')[0] + `.${key}` : path.split('.')[0] + `.${key}`);
          const groupInp = input.groupInputs[key];
          const inputData = getData(
            groupInp.dataId || key,
            input.groupInputs[key],
            dot.pick(newPath, values),
            null,
            newPath
          );
          return {
            path: newPath,
            type: input.groupInputs[key].inputType,
            data: inputData,
            forms: {
              form: MainForm,
              allForms: plainForms,
              values,
              setFormValues: setValues,
              setAddress
            },
          }
        }),
      });
    }

    return config;
  }

  useEffect(() => {
    setValues({
      ...values,
      ...formData
    });
    if (MainForm.setFieldsValue && isModal) {
      // TODO: Need to check this one the error of date was here;
      // MainForm.resetFields();
      // MainForm.setFieldsValue({
      //   ...values,
      //   ...formData
      // });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const renderAlert = () => {
    if (options.alertConf && options.alertConf.type === 'warning') {
      if (options.warningComponent) {
        switch (options.warningComponent) {
          case "typesOfRisksCovered":
            return (
              <TypesOfRisksCovered
                t={t}
                canEdit
                body={form ? (form.outputLabel || getInputLabel(form, data)) : ''}
              />
            );
          case "additionalCRAFTRequirements":
            return (
              <AdditionalCRAFTRequirements
                t={t}
                canEdit
                body={form ? (form.outputLabel || getInputLabel(form, data)) : ''}
              />
            );
          default:
        }
      }

      if (options.alertConf.text) {
        return <Alert message={options.alertConf.text} type={options.alertConf.type} showIcon />
      }
    }

    return null;
  };

  return <div className={`${!isModal ? 'form-edit' : 'form-modal'} ${hasSections ? 'has-section' : ''}`}>
    <div className="content-card">
      {options.alertConf && typeof options.alertConf === "object" ? renderAlert() : (
        <>
          {breadcrumb}
          {(form.label && layout === layoutTypes.DEFAULT) && (
            <CustomWrapper
              t={t}
              type="header"
              body={form.label}
              icon={form.icon}
              formDescription={form.options.formDescription}
            />
          )}
          <Form
            form={MainForm}
            autoComplete="new-password"
            key={`${id}-${uuid}`}
            name={`${id}-${uuid}`}
            layout="vertical"
            className={`main-form${formClass ? ` ${formClass}` : ''} ${layout === layoutTypes.PROJECT ? 'documents-layout' : ''}`}
            onValuesChange={(changedValue, allValues) => {
              onValuesChange(changedValue, {
                ...values,
                ...allValues,
              });
              setValues({
                ...values,
                ...allValues
              });
            }}
          >
            {(form.label && (layout === layoutTypes.DOCUMENTS_LAYOUT || layout === layoutTypes.PROJECT)) && (
              <div className="edit-form-header">
                <h1>{form.label}</h1>
              </div>
            )}
            <div className={formatClassname(['edit-form-body', layout === layoutTypes.DOCUMENTS_LAYOUT && 'documents-layout'])}>
              {introText && introText !== '' ? <p className="repeatable">{introText}</p> : null}
              {Object.keys(options)
                .filter(k => !excludedKeys.includes(k) &&
                  showHideInput(options[k], values, undefined, undefined, setValues, k)
                ).map((k, i) => {
                  if (options[k].inputs) {
                    if ((!values[k] || !values[k].length) && options[k].mapWhenEmpty) {
                      Object.assign(values, {
                        // eslint-disable-next-line no-eval
                        [k]: eval(options[k].mapWhenEmpty)(options[k]),
                      });
                    }
                    return <NestedInput
                      options={options}
                      k={k}
                      setValues={setValues}
                      values={values}
                      excludedKeys={excludedKeys}
                      i={i}
                      formTitles={formTitles}
                      getData={getData}
                      MainForm={MainForm}
                      plainForms={plainForms}
                      setAddress={setAddress}
                      currentField={currentField}
                      setCurrentField={setCurrentField}
                    />
                  } else {
                    const input = options[k];
                    const inputId = input.dataId || k;
                    const value = values[inputId];
                    const commentValue = values[`${inputId}Comment`];
                    const inputData = getData(inputId, input, value, commentValue, inputId, inputId);
                    return showHideInput(input, values, undefined, undefined, setValues, inputId) ? <React.Fragment key={i}>
                      {getFormTitles(formTitles, inputData.name, i)}
                      {getFormItem({
                        inputData,
                        inputId,
                        input,
                        values,
                        MainForm,
                        options,
                        plainForms,
                        setValues,
                        setAddress,
                        i,
                        setLoading
                      })}
                    </React.Fragment> : null
                  }
                })}
            </div>
          </Form>
          {(values && !isModal && layout === layoutTypes.DEFAULT) ? <CustomWrapper t={t} type="comment" defaultValue={values[`${id}Comment`] || null} onChange={ev => {
            setValues({
              ...Object.assign(values, { [`${id}Comment`]: ev.currentTarget.value }),
              ...allValues
            });
            onValuesChange({ [`${id}Comment`]: ev.currentTarget.value }, {
              ...values,
              ...allValues
            });
          }} /> : null}
          {isModal && (
            <div className="form-botom text-center">
              <Button
                type="primary"
                className="mr-2"
                onClick={async (ev) => {
                  ev.stopPropagation();
                  MainForm.validateFields().then(() => {
                    const formV = MainForm.getFieldsValue();
                    onSubmit({
                      ...values,
                      ...formV
                    });
                  }).catch(e => { });
                }}>
                {i18next.t('Save')}
              </Button>
              <Button
                onClick={(ev) => onCancel()}>
                {i18next.t('Cancel')}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  </div>
}
